// import { setActiveMenuItem } from "./activeMenu";
// import { Filter } from "./filter";
// import { LightBox } from "./g-light-box";
// import { Hero } from "./home";
import { LenisScroll } from "./lenis";
import { Menu } from "./menu";
import { SwiperMarquee } from "./swiper-marquee";
import { Reveal } from "./reveal";
// import { HeroDatePicker, QuartosHospedesCounter } from "./booking";
// import { SwiperRooms } from "./swiper-rooms";
// import { SwiperJoaoPessoa } from "./swiper-joao-pessoa";
// import { SwiperTestimonials } from "./swiper-testimonials";
// import { SwiperProgressData } from "./swiper-progress-data";
// import { SwiperProjectGallery } from "./swiper-project-gallery";
// import { SwiperProjectGallery2 } from "./swiper-project-gallery2";
// import { SwiperProjectPlants } from "./swiper-project-plants";
// import { Tabs } from "./tabs";
import GLightbox from "glightbox";

export const Init = () => {
	LenisScroll();
	Menu();
	GLightbox({ selector: ".glightbox" });
	Reveal();
	if (document.querySelector(".swiper-marquee")) SwiperMarquee();
	// if (document.querySelector(".hero")) Hero();
	// if (document.querySelector(".swiper-imoveis-home")) SwiperImoveisHome();
	// if (document.querySelector(".swiper-project-gallery"))
	// SwiperProjectGallery();
	// if (document.querySelector(".swiper-project-gallery2"))
	// SwiperProjectGallery2();
	// if (document.querySelector(".swiper-project-plants")) SwiperProjectPlants();
	// if (document.querySelector(".swiper-home")) SwiperHeroHome();
	// if (document.querySelector(".swiper-rooms")) SwiperRooms();
	// if (document.querySelector(".swiper-joao-pessoa")) SwiperJoaoPessoa();
	// if (document.querySelector(".swiper-testimonials")) SwiperTestimonials();
	// if (document.querySelector(".swiper-progress-data")) SwiperProgressData();
	// if (document.querySelector(".tabs")) Tabs();
	// if (document.querySelector(".site-terms")) Filter();
	// if (document.querySelector(".g-light-box")) LightBox();
};
